<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'width': 'auto','min-width':'850px','max-width':'1100px','max-height':'720px'}">


        <Table  max-height="570" border :columns="titleName" :data="tableData"  :loading='loading'></Table>
        
        <Button type="info" v-if='tableData.length>0' :disabled='disabled'  @click="subData" style="margin-top:18px; border-radius: 6px;">{{$t("save")}}</Button>

        <NumberType        :showSetModel.sync="IndentyNameBox.showSetModelNumber"   :languageKey='IndentyNameBox.key'  :initdata="IndentyNameBox.initdata"   :DataType='IndentyNameBox.formatType+""' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></NumberType>
        <BooleanType       :isGener='true'   :showSetModel.sync="IndentyNameBox.showSetModelBoolean"  :languageKey='IndentyNameBox.key'  :initdata="IndentyNameBox.initdata"   :DataType='IndentyNameBox.formatType+""' :editFormData="IndentyNameBox.editFormData"   :fn="IndentyNameBox.callbackFn"></BooleanType>
        <TimeType          :showSetModel.sync="IndentyNameBox.showSetModelTime"     :languageKey='IndentyNameBox.key'  :initdata="IndentyNameBox.initdata"   :DataType='IndentyNameBox.formatType+""' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></TimeType>
        <EnumerationType   :showSetModel.sync="IndentyNameBox.showSetModelEnumer"   :languageKey='IndentyNameBox.key'  :initdata="IndentyNameBox.initdata"   :DataType='IndentyNameBox.formatType+""' :editFormData="IndentyNameBox.editFormData"  :fn="IndentyNameBox.callbackFn"></EnumerationType>
        <BitvalueType      :showSetModel.sync="IndentyNameBox.showSetModelBitvalue" :languageKey='IndentyNameBox.key'  :initdata="IndentyNameBox.initdata"   :DataType='IndentyNameBox.formatType+""' :editFormData="IndentyNameBox.editFormData"  :fn="IndentyNameBox.callbackFn"></BitvalueType>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import NumberType from './component/numberType.vue'
import BooleanType from './component/enumerationBool'
import TimeType from './component/timeType.vue'
import EnumerationType from './component/enumerationType'
import BitvalueType from './component/bitvalueType.vue'
import {stringToJson} from '@/libs/tools.js'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object
        },
        name: "temModel",
        components: {
            NumberType,      
            BooleanType,    
            TimeType,       
            EnumerationType,
            BitvalueType, 
        },
        data() {
            return {   
                loading:false,
                title: '',//弹框标题
                disabled:false,
                tableData:[],
                IndentyNameBox:{
                    showSetModelNumber:false,
                    showSetModelBoolean:false,
                    showSetModelTime:false,
                    showSetModelEnumer:false,
                    showSetModelBitvalue:false,
                    editFormData:{},
                    key:{},
                    initdata:{},
                    formatType:0,
                    callbackFn:(e)=>{}
                },
                wordList:[]
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                    this.getWordList()
                }
            },
        },
        computed:{
            local(){
                return this.$store.state.local
            },
            localLang(){
               let lang = this.local
               let obj = {'zh-CN':'CN','en-US':'EN'}
               let cur = obj[lang] || ''
               return cur
            },
            titleName(){
                return [
                    {
                        title: this.$t('productManage.functionModel.titleName.FunctionGroup'),
                        key: 'keyName',
                        minWidth: 180,
                        render: (h, params) => {
                            let lang = this.local
                            let objLang = {'zh-CN':'CN','en-US':'EN'}
                            let key = objLang[lang] || ''
                            let obj = stringToJson(params.row.keyName)
                            let stext = params.row.keyName
                            if(Object.prototype.toString.call(obj)=='[object Object]'){
                                stext = obj[key]
                            }else if(Object.prototype.toString.call(obj)=='[object Array]'){
                                 stext = obj[0].IndentyName
                                obj.map((item=>{
                                    if(item.LanguageKey==key){
                                        stext = item.IndentyName
                                    }
                                }))
                                if(!stext){
                                    stext = params.row.keyName
                                }

                            }
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
					    }
                    },
                    {
                        title: this.$t('BasicProduct.funcBox.titleName.DataType'),
                        key: 'formatType',
                        width: 150,
                        render:(h, params)=>{
                            let stext = '' 
                            let List = {'1':'Numerical','2':'Enumeration','3':'Boolean','4':'String','5':'Bitvalue','6':'Date time','7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime','13':'Structure','14':'Hex SNumerical'}
                            let nameFlag = List[params.row.formatType]
                            
                            if(!nameFlag){
                                stext =params.row.formatType
                            }else{
                                stext = nameFlag
                            }
                            return h('div',{
                                attrs:{
                                    title:stext
                                },
                                on: {
					                'click': (val) => { 
                                        // this.editTypeDiscription(params.row)
                                    }
					            }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('productManage.functionModel.titleName.Discription'),
                        key: 'defaultValue',
                        minWidth: 180,
                        render: (h, params) => {
                            // let obj = JSON.parse(params.row.formatContent);
                            // let stext1 = params.row.formatContent
                            // stext1 = stext1.replace(/{|}|"/g, "");//替换
                            // stext1 = stext1.replace(/,/g, ",  ");//替换

                            // let stext = stext1


                            //1-数值型，2-枚举型，3-布尔型，4-字符型，5-位值型，6-时间型，7-数值型(16进制)，8-枚举型(16进制)，9-布尔型(16进制)，10-字符型(16进制)，11-位值型(16进制)，12-时间型(16进制),13 strcuture,14 有符号数值型
                            let stext = params.row.formatContent || ''
                            let sarr = null;
                            try {
                                sarr = JSON.parse(params.row.formatContent)
                            } catch (u) {}
                            let formatType = params.row.formatType
                            let sarrType = Object.prototype.toString.call(sarr)
                            let lang = this.localLang

                            if(sarrType=='[object Array]' && this.wordList.length){
                                sarr.map(item=>{
                                    this.wordList.map(sitem=>{
                                        if(sitem.id==item.wordId){
                                            if(item.hasOwnProperty('Name-CN')){
                                                item['Name-CN'] = sitem.simpleChinese
                                                item['Name-EN'] = sitem.englishText
                                            }
                                            if(item.hasOwnProperty('Unit-CN')){
                                                item['Unit-CN'] = sitem.simpleChinese
                                                item['Unit-EN'] = sitem.englishText
                                            }
    
                                        }
                                        if(sitem.id==item['0x00 wordId']){
                                                item['0x00-CN'] = sitem.simpleChinese
                                                item['0x00-EN'] = sitem.englishText
                                        }
                                        if(sitem.id==item['0x01 wordId']){
                                                item['0x01-CN'] = sitem.simpleChinese
                                                item['0x01-EN'] = sitem.englishText
                                        }
                                        if(sitem.id==item['False wordId']){
                                                item['False-CN'] = sitem.simpleChinese
                                                item['False-EN'] = sitem.englishText
                                        }
                                        if(sitem.id==item['True wordId']){
                                                item['True-CN'] = sitem.simpleChinese
                                                item['True-EN'] = sitem.englishText
                                        }
                                    })
                                    
                                })
    
                            }
    
                            if(formatType==1 || formatType==7 || formatType==14){
                                
                                let obj = {}
                          
                                if(Array.isArray(sarr) && sarr[0]){
                                    obj = {...sarr[0]}
                                    obj.Unit = (sarr[0])['Unit-'+lang]
                                    stext = this.$t('BasicProduct.funcBox.titleName.ValueRange')+' '+ obj.Min+'~'+obj.Max
                                }else if(sarrType=='[object Object]' && sarr['Max']){
                                    stext = this.$t('BasicProduct.funcBox.titleName.ValueRange')+' '+ sarr.Min+'~'+sarr.Max
                                }
    
    
                            }else if(formatType==2 || formatType==8 || formatType==3 || formatType==9){
                                let resArr = {}
                                let arr = null
                                try {
                                    arr = sarr[0]
                                } catch (u) {}
                                if(Object.prototype.toString.call(arr)=='[object Array]'){
                                    arr.map(item=>{
                                      resArr[item.Code]=item['Name-'+lang]
                                    //   obj['LanguageKey'] = item['LanguageKey']
                                   })
                                   if(Object.values(resArr)[0]) stext = JSON.stringify(resArr)
    
                                }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                    sarr.map(item=>{
                                      resArr[item.Code]=item['Name-'+lang]
                                   })
                                   if(Object.values(resArr)[0]) stext = JSON.stringify(resArr)
                                }

                               if(formatType==9){
                                    let resArr = {}
                                    let arr = null
                                    try {
                                        arr = sarr[0]
                                    } catch (u) {}
                                    if(Object.prototype.toString.call(arr)=='[object Array]'){
                                        arr.map(item=>{
                                          if(item['0x00-'+lang]){
                                              resArr['0x00']=item['0x00-'+lang]
                                              resArr['0x01']=item['0x01-'+lang]
                                          }
                                       })
                                        if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
        
                                    }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                        sarr.map(item=>{
                                            if(item['0x00-'+lang]){
                                                resArr['0x00']=item['0x00-'+lang]
                                                resArr['0x01']=item['0x01-'+lang]
                                            }
                                       })
                                       if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
                                    }
                                }
                                if(formatType==3){
                                    let resArr = {}
                                    let arr = null
                                    try {
                                        arr = sarr[0]
                                    } catch (u) {}
                                    if(Object.prototype.toString.call(arr)=='[object Array]'){
                                        arr.map(item=>{
                                          if(item['False-'+lang]){
                                              resArr['False']=item['False-'+lang]
                                              resArr['True']=item['True-'+lang]
                                          }
                                       })
                                        if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
        
                                    }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                        sarr.map(item=>{
                                            if(item['False-'+lang]){
                                                resArr['False']=item['False-'+lang]
                                                resArr['True']=item['True-'+lang]
                                            }
                                       })
                                       if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
                                    }
                                }
                                


                            }else if(formatType==3){
                                let resArr = {}
                                let arr = null
                                try {
                                    arr = sarr[0]
                                } catch (u) {}
                                if(Object.prototype.toString.call(arr)=='[object Array]'){
                                    arr.map(item=>{
                                      resArr['False']=item['False-'+lang]
                                      resArr['True']=item['True-'+lang]
                                   })
                                   if(Object.values(resArr)[0])   stext = JSON.stringify(resArr)
    
                                }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                    sarr.map(item=>{
                                      resArr['False']=item['False-'+lang]
                                      resArr['True']=item['True-'+lang]
                                   })
                                   if(Object.values(resArr)[0]) stext = JSON.stringify(resArr)
                                }
                            }else if(formatType==9){
                                let resArr = {}
                                let arr = null
                                try {
                                    arr = sarr[0]
                                } catch (u) {}
                                if(Object.prototype.toString.call(arr)=='[object Array]'){
                                    arr.map(item=>{
                                      resArr['0x00']=item['0x00-'+lang]
                                      resArr['0x01']=item['0x01-'+lang]
                                   })
                                    if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
    
                                }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                    sarr.map(item=>{
                                      resArr['0x00']=item['0x00-'+lang]
                                      resArr['0x01']=item['0x01-'+lang]
                                   })
                                   if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
                                }

                            }else if(formatType==6 || formatType==12){
                                stext = sarr[0].label
                            }else if(formatType==13){
                                stext = ''
                            }else if(formatType==11){
                                let resArr = []
                                let arr = null
                                try {
                                    arr = sarr[0]
                                } catch (u) {}
                                if(Object.prototype.toString.call(arr)=='[object Array]'){
                                    let obj = {}
                                    arr.map(item=>{
                                      item['Name']=item['Name-'+lang]
                                      delete item['Name-CN']
                                      delete item['Name-EN']
                                      obj = {...item}
                                      resArr.push(obj)
                                   })
                                  if(Object.values(resArr)[0])  stext = JSON.stringify(resArr)
    
                                }else if(Object.prototype.toString.call(arr)=='[object Object]' && Array.isArray(sarr)) {
                                    let obj = {}
                                    sarr.map(item=>{
                                      item['Name']=item['Name-'+lang]
                                      delete item['Name-CN']
                                      delete item['Name-EN']
                                      obj = {...item}
                                      resArr.push(obj)
                                   })
                                  if(Object.values(resArr)[0]) stext = JSON.stringify(resArr)
                                }
                            }

                            
                            return h('div',{
                                attrs:{
                                    title:stext
                                },
                                style:{
                                    cursor:'pointer'
                                },
                                on:{
                                    click:()=>{this.editTypeDiscription(params.row)}
                                }
                            },stext || '')
					    }
                    },
                    {
                        title: this.$t('productManage.functionModel.titleName.defaultValue'),
                        key: 'defaultValue',
                        minWidth: 180,
                        render:(h, params)=>{
                            // let List = {'7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime'}
                            let List = {'7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime','14':'Hex SNumerical'}
                            let nameFlag = List[params.row.formatType]
                            let stext =nameFlag&&params.row.defaultValue  ? '0x'+params.row.defaultValue : params.row.defaultValue
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title: this.$t('productManage.functionModel.titleName.Musted'),
                        key: 'required',
                        minWidth: 180,
                        render: (h, params) => {
                            let stext = params.row.required ? this.$t('yes'):this.$t('no')
                            // console.log(obj)
                            
                            return h('div',{},stext || '')
					    }
                    },
                    {
                        title: this.$t('productManage.functionModel.titleName.major'),
                        key: 'whetherMajor',
                        minWidth: 180,
                        render: (h, params) => {
                            let stext = params.row.whetherMajor ? this.$t('yes'):''
                            // console.log(obj)
                            
                            return h('div',{},stext || '')
					    }
                    },
                    {
					    title: this.$t('productManage.functionModel.titleName.Select'),
					    minWidth:120,
                        key: "id",
                        // fixed:'right',
					    render: (h, params) => {
                            let that = this
                            return [
                                h('Checkbox', {
					                props: {
                                        disabled:params.row.required,
                                        value:params.row.required || params.row.chooseToUse
                                    },
                                    style:{
                                        display:'block',
                                        margin:'0 auto'
                                    },
					                on: {
					                    'on-change': (val) => { 
                                            this.tableData[params.index].chooseToUse = val
                                        }
					                }
					            })
                            ]
					    }
					},
                ]
            }

        },
        methods: {
            getData(){//获取功能数据
            //    console.log(this.editFormData)
                this.loading = true
                let id = this.editFormData.id 
                // let id = 188 
                this.axios.post(this.config.urlArray.functionList, {dealerProductTypeId:id}).then((result) => {
                    // common.ajaxMsg(result.data,true,false);
                     common.ajaxMsg(result.data,false,()=>{

                         let resData = result.data.data
                         //处理数组
                         this.tableData  =  resData
                         this.loading = false
                     },()=>{
                         this.loading = false
                     })
                })
            },
            async getWordList(){
                let params={
                        page:1,
                        limit:100000,
                        pageId:this.editFormData.pageId
                    }
                let  result = await this.axios.post(this.config.urlArray.pagesLangDictionaryList,params)
                if(result){
                    this.wordList = result.data.data.dealersList
                }
                
            },
            hideModel(){
                this.IndentyNameBox.showSetModelNumber = false;
                this.IndentyNameBox.showSetModelBoolean = false;
                this.IndentyNameBox.showSetModelTime = false;
                this.IndentyNameBox.showSetModelEnumer = false;
                this.IndentyNameBox.showSetModelBitvalue = false;
            },
            showTypeModel(item){
                //  console.log('itemitem',item)
                 if(item.formatType==1 || item.formatType==7 || item.formatType==14){
                     this.IndentyNameBox.showSetModelNumber = true
                 }else if(item.formatType==3 || item.formatType==9){
                     this.IndentyNameBox.showSetModelBoolean = true
                 }else if(item.formatType==12 || item.formatType==6){
                     this.IndentyNameBox.showSetModelTime = true
                 }else if(item.formatType==8 || item.formatType==2){
                     this.IndentyNameBox.showSetModelEnumer = true
                 }else if(item.formatType==11){
                     this.IndentyNameBox.showSetModelBitvalue = true
                 }
            },
            editTypeDiscription(item,index=0){//编辑数据类型详细
                let arr = ['2','3','8','9','11']
                this.showTypeModel(item)
                // console.log('item',item)
                let formatContentArr = arr.includes(item.formatType)?[stringToJson(item.formatContent)]:stringToJson(item.formatContent)
                 this.IndentyNameBox.editFormData = {IndentyName:formatContentArr,allArr:formatContentArr}
                 this.IndentyNameBox.formatType = item.formatType

                //  console.log('type',item.formatType)
                //  console.log('formatContentArr',formatContentArr)

                 if(item.formatType==8 || item.formatType==2){//枚举型
                     this.IndentyNameBox.key = {key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey'}
                     this.IndentyNameBox.initdata = {'Name-CN':'',"Name-EN":"",Code:'',LanguageKey : '',index: 1,status: 1}
                 }else if(item.formatType==11){//Hex Bitvalue
               
                      this.IndentyNameBox.key = {key1:'Name-CN', key7:"Name-EN",key2:'Offset',key3:'Len',key4:'Multiple',key5:'Negative',key6:'LanguageKey'}
                      this.IndentyNameBox.initdata = {'Name-CN':'',"Name-EN":"",Offset:'',Len:'',Multiple:'',Negative:'',LanguageKey : '',index: 1,status: 1}
                 }else if(item.formatType==9){//hex boolean
                   
                     this.IndentyNameBox.key = {key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey'}
                     this.IndentyNameBox.initdata = [{'Name-CN':'',"Name-EN":"",Code:'0x00',LanguageKey : '',index: 1,status: 1},{'Name-CN':'',"Name-EN":"",Code:'0x01',LanguageKey : '',index: 2,status: 1}]
                 
                 }else if(item.formatType==3){//boolean
                     this.IndentyNameBox.key = {key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey'}
                     this.IndentyNameBox.initdata = [{'Name-CN':'',"Name-EN":"",Code:'False',LanguageKey : '',index: 1,status: 1},{'Name-CN':'',"Name-EN":"",Code:'True',LanguageKey : '',index: 2,status: 1}]
                 }
                //   this.showTypeModel()
                  this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                    //重新载入
                    // console.log('editarr',arr)
                    this.hideModel()
                    if(item.formatType==8 || item.formatType==2 || item.formatType==11 || item.formatType==9 || item.formatType==3){
                        item.formatContent[index] = [...arr]
                    }else{
                        item.formatContent[index] = {...arr}
                    }
                    // console.log( item.formatContent,index)
                }

            },
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('productManage.functionModel.title')
                } else { //关闭弹框后要做的处理
                    // this.fn()
                }
            },
            subData() {//更改,已关联订单的型号不能再改功能
                let arr = [];
                this.tableData.map(item=>{
                    let obj = {
                        id:item.id,
                        dealerProductTypeId:this.editFormData.id,
                        chooseToUse:item.required || item.chooseToUse
                    }
                    arr.push(obj)
                })
                this.disabled = true

                
                this.axios.post(this.config.urlArray.functionEdit, arr).then((result) => {
                    common.ajaxMsg(result.data,true,()=>{
                        this.cancel()
                        this.fn()
                        
                    },()=>{this.disabled = false});
                    
                }).catch((err) => {
                    this.disabled = false
                    console.log(err)
                });
            },
            cancel() {//对话框关闭
                this.disabled = false
                this.$emit('update:showModel',false);
            }
        }
    }
</script>
<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
}
/deep/ .ivu-table-fixed-body{
    height: 100% !important;
    max-height: 531px;
}
/deep/ .ivu-modal-body{
    text-align: center;
}
.goodsCon{
     flex-wrap: wrap;
      // overflow-y: scroll;
     overflow: auto;
     max-height: 500px;
     .goodsItemCon{
         width:46%;
         margin-left: 2%;
         margin-bottom: 20px;
     }
     .goodsItem{
        
         background-color: #fff;
         border: 2px solid #E5E5E5;
         border-radius: 10px;
         padding: 20px 30px;
        
         min-width: 193px;
         overflow-x: hidden;
         cursor: pointer;
         .imgCon{
             width: 120px;
             height: 120px;
             margin: 0 auto;
             img{
                 width: auto;
                 height: 100%;
                 max-width: calc(100% + 90px);
             }
         }
         .goodName{
             color: #3A464E;
             margin-top: 7px;
             text-align: center;
         }
         .bottomInfo{
             margin-top: 20px;
             color: #3A464E;
             text-align: center;
             line-height: normal;
             .desc{
                 font-size: 12px;
                 color: #A4B4BF;
                 margin-top: 15px;
             }
             .dataNum{
                 height: 26px;
                 line-height: 26px;
             }
             .numCon{
                font-size: 20px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #E76D6A;
             }
         }
     }
     .selectButton{
         margin-top: 10px;
         position: relative;
         left: 50%;
         transform: translateX(-50%);
     }
 }
</style>